import React, { FC, ReactElement } from 'react';
import { Box, Grid } from '@material-ui/core';
import baseConfiguratorLayoutStyles from './baseConfiguratorLayoutStyles';
import clsx from 'clsx';

export interface IBaseConfiguratorLayoutProps {
  leftSlot: ReactElement;
  rightSlot: ReactElement;
  footerSlot: ReactElement;
  disclaimerSlot?: ReactElement;
  navigationSlot?: ReactElement;
  classes?: string;
}

const BaseConfiguratorLayout: FC<IBaseConfiguratorLayoutProps> = ({
  leftSlot,
  rightSlot,
  footerSlot,
  disclaimerSlot,
  navigationSlot,
  classes,
}) => {
  const styles = baseConfiguratorLayoutStyles();

  return (
    <>
      {navigationSlot}
      <Grid container={true} classes={{ container: styles.layoutContainer }}>
        <Grid item={true} xs={12} md={8} className={styles.sliderContainer}>
          <Box my={5} className={clsx([styles.variantSliderContainer, classes])}>
            {leftSlot}
          </Box>
        </Grid>
        {rightSlot}
      </Grid>
      <Box className={styles.footerContainer}>{footerSlot}</Box>
      {disclaimerSlot}
    </>
  );
};

export default BaseConfiguratorLayout;
